// <auto-generated />
// The class was autogenerated by .services.tst.
// Any manual changes made to this file will be lost. To regenerate the content,
// right click .services.tst and select 'Render Template'. Please note that you
// must have the Typewriter Visual Studio extension installed for this to work.
import Axios, { AxiosRequestConfig } from "axios";
import * as qs from "qs";
import { AddConfigArgs } from "./AddConfigArgs";
import { BindAndSaveDeviceArgs } from "./BindAndSaveDeviceArgs";
import { BindAndSaveLogicArgs } from "./BindAndSaveLogicArgs";
import { BindAndSaveSupportArgs } from "./BindAndSaveSupportArgs";
import { BindLogicPfdAndStrArgs } from "./BindLogicPfdAndStrArgs";
import { BindLogicTIYearsArgs } from "./BindLogicTIYearsArgs";
import { BindPasteAndSaveDeviceArgs } from "./BindPasteAndSaveDeviceArgs";
import { CalculationResponse } from "./CalculationResponse";
import { ChangeRedundancyObject } from "./ChangeRedundancyObject";
import { DeleteDeviceArgs } from "./DeleteDeviceArgs";
import { DeviceBarDevices } from "./DeviceBarDevices";
import { DeviceBarDevicesAndPfString } from "./DeviceBarDevicesAndPfString";
import { DeviceData } from "./DeviceData";
import { DiagramData } from "./DiagramData";
import { DM_DataSheet } from "./DM_DataSheet";
import { DM_DataSheet_Bar } from "./DM_DataSheet_Bar";
import { DM_PT_DataSheet } from "./DM_PT_DataSheet";
import { GetDataSheetObject } from "./GetDataSheetObject";
import { GetLogicSolverParams } from "./GetLogicSolverParams";
import { GuiReportData } from "./GuiReportData";
import { LSM_LogicSolverSheet } from "./LSM_LogicSolverSheet";
import { LSM_LogicSolverSheet_Bar } from "./LSM_LogicSolverSheet_Bar";
import { LSM_PT_LogicSolverSheet } from "./LSM_PT_LogicSolverSheet";
import { LST_LogicSolverSheetList } from "./LST_LogicSolverSheetList";
import { ManualAction } from "./ManualAction";
import { ManualInputs } from "./ManualInputs";
import { Position_DeleteDeviceArgs } from "./Position_DeleteDeviceArgs";
import { PositionPasteAndSaveDeviceArgs } from "./PositionPasteAndSaveDeviceArgs";
import { PromoteDeviceToClientLevelArgs } from "./PromoteDeviceToClientLevelArgs";
import { ProtectiveFunction } from "./ProtectiveFunction";
import { PSF_ProtectiveFunctionComments } from "./PSF_ProtectiveFunctionComments";
import { PT_ProtectiveFunction } from "./PT_ProtectiveFunction";
import { SaveCCFVotingParams } from "./SaveCCFVotingParams";
import { SS_PT_SupportSystemSheet } from "./SS_PT_SupportSystemSheet";
import { SS_SupportSystemSheet } from "./SS_SupportSystemSheet";
import { SS_SupportSystemSheet_Bar } from "./SS_SupportSystemSheet_Bar";
import { TargetSpecUpdateParams } from "./TargetSpecUpdateParams";
import { UpdateLogicSolverDataArgs } from "./UpdateLogicSolverDataArgs";
import { UserDetails } from "./UserDetails";

export class DiagramApiController {
   static readonly getDeviceListParams = {
       projectId: "projectId"
   };

   static readonly getProtectiveFunctionParams = {
       id: "id"
   };

   static readonly changeProtectiveFunctionRedundancyParams = {
       changeRedundancyObject: "changeRedundancyObject"
   };

   static readonly getDiagramDataParams = {
       id: "id"
   };

   static readonly addConfigurationParams = {
       args: "args"
   };

   static readonly bindAndSaveDeviceParams = {
       args: "args"
   };

   static readonly updateSupportSystemParams = {
       args: "args"
   };

   static readonly saveSFT_TargetsParams = {
       targetSpecUpdateParams: "targetSpecUpdateParams"
   };

   static readonly prohibitChangesParams = {
       pfId: "pfId",
       diagramData: "diagramData"
   };

   static readonly promoteDeviceToClientLevelParams = {
       args: "args"
   };

   static readonly checkForCheckoutNmaeParams = {
       pfd: "pfd"
   };

   static readonly bindAndSaveLogicParams = {
       args: "args"
   };

   static readonly bindAndSaveSupportParams = {
       args: "args"
   };

   static readonly bindLogicSolverParams = {
       logicSolverParams: "logicSolverParams"
   };

   static readonly bindLogicvotingParams = {
       pt_protectiveFunctionIdOfLogicSolver: "pt_protectiveFunctionIdOfLogicSolver"
   };

   static readonly bindLogicvotingsParams = {
       logicSource: "logicSource",
       logicDeviceId: "logicDeviceId"
   };

   static readonly bindLogicTIYearsParams = {
       args: "args"
   };

   static readonly bindLogicPfdandStrParams = {
       args: "args"
   };

   static readonly updateLogicSolverDataParams = {
       args: "args"
   };

   static readonly bindPasteAndSaveDeviceParams = {
       args: "args"
   };

   static readonly bindSupportSystemParams = {
       getDataSheetObject: "getDataSheetObject"
   };

   static readonly bindDeviceSheetParams = {
       getDataSheetObject: "getDataSheetObject"
   };

   static readonly restoreDeviceSheetDataParams = {
       protectiveFunctionId: "protectiveFunctionId",
       protectiveId_FK: "protectiveId_FK"
   };

   static readonly calculationParams = {
       protectiveFunctionId: "protectiveFunctionId"
   };

   static readonly updateDeviceSheetDataParams = {
       args: "args"
   };

   static readonly saveCCFVotingParams = {
       model: "model"
   };

   static readonly getPtProtectiveFunctionsParams = {
       id: "id"
   };

   static readonly getReportDataParams = {
       projectId: "projectId",
       protectiveFunctionId: "protectiveFunctionId"
   };

   static readonly saveManualInputsParams = {
       protectiveFunctionId: "protectiveFunctionId",
       manualInputs: "manualInputs"
   };

   static readonly saveManualActionParams = {
       protectiveFunctionId: "protectiveFunctionId",
       manualAction: "manualAction"
   };

   static readonly createManualInputsParams = {
       protectiveFunctionId: "protectiveFunctionId"
   };

   static readonly createManualActionParams = {
       protectiveFunctionId: "protectiveFunctionId"
   };

   static readonly deleteDeviceParams = {
       args: "args"
   };

   static readonly deleteManualActionParams = {
       protectiveFunctionId: "protectiveFunctionId"
   };

   static readonly deleteManualInputsParams = {
       protectiveFunctionId: "protectiveFunctionId"
   };

   static readonly openDeviceSheetParams = {
       deviceId: "deviceId"
   };

   static readonly openSupportSheetParams = {
       supportSystemId: "supportSystemId"
   };

   static readonly openLogicSolverParams = {
       logicSolverId: "logicSolverId"
   };

   static readonly position_DeleteDeviceParams = {
       args: "args"
   };

   static readonly positionPasteAndSaveDeviceParams = {
       args: "args"
   };

   static readonly upgradeProtectiveFunctionParams = {
       protectiveFunctionId: "protectiveFunctionId"
   };

   static readonly userHasCustomDeviceRightsParams = {
   };

   static readonly saveCustomDeviceSheetParams = {
       dm_dataSheet: "dm_dataSheet",
       projectId: "projectId"
   };

   static readonly saveCustomLogicSolverParams = {
       lsm_LogicSolverSheet: "lsm_LogicSolverSheet",
       projectId: "projectId"
   };

   static readonly saveCustomSupportSystemParams = {
       ss_supportSystemSheet: "ss_supportSystemSheet",
       projectId: "projectId"
   };

   static readonly deleteCustomDeviceSheetParams = {
       dm_dataSheet: "dm_dataSheet",
       projectId: "projectId"
   };

   static readonly deleteCustomLogicParams = {
       lsm_logicSolverSheet: "lsm_logicSolverSheet",
       projectId: "projectId"
   };

   static readonly deleteCustomSupportParams = {
       ss_SupportSystemSheet: "ss_SupportSystemSheet",
       projectId: "projectId"
   };

   static readonly saveProcessHazardParams = {
       pSF_ProtectiveFunctionComments: "pSF_ProtectiveFunctionComments"
   };

   static readonly saveDescriptionParams = {
       pSF_ProtectiveFunctionComments: "pSF_ProtectiveFunctionComments"
   };

   static readonly saveDiagnosticsParams = {
       pSF_ProtectiveFunctionComments: "pSF_ProtectiveFunctionComments"
   };

   static readonly saveResetParams = {
       pSF_ProtectiveFunctionComments: "pSF_ProtectiveFunctionComments"
   };

   static readonly saveShutdownParams = {
       pSF_ProtectiveFunctionComments: "pSF_ProtectiveFunctionComments"
   };

   static readonly saveReferenceParams = {
       pSF_ProtectiveFunctionComments: "pSF_ProtectiveFunctionComments"
   };

   static readonly saveCommentsParams = {
       pSF_ProtectiveFunctionComments: "pSF_ProtectiveFunctionComments"
   };

   static readonly updateProtectiveFunctionLockParams = {
       id: "id"
   };

   static readonly isLockedParams = {
       pf: "pf"
   };

   static readonly releaseProtectiveFunctionLockParams = {
       id: "id"
   };

   static readonly getUserDetailsParams = {
   };

   static async getDeviceList(projectId: number, config?: Partial<AxiosRequestConfig>): Promise<DeviceBarDevices> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: null,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/getDeviceList?projectId=${projectId}`
           });
       return request.data;
   }

   static async getProtectiveFunction(id: number, config?: Partial<AxiosRequestConfig>): Promise<ProtectiveFunction> {
       const request =
           await Axios({
               ...config,
               method: "get",
               params: null,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/getProtectiveFunction?id=${id}`
           });
       return request.data;
   }

   static async changeProtectiveFunctionRedundancy(changeRedundancyObject: ChangeRedundancyObject, config?: Partial<AxiosRequestConfig>): Promise<DiagramData> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: changeRedundancyObject,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/changeProtectiveFunctionRedundancy`
           });
       return request.data;
   }

   static async getDiagramData(id: number, config?: Partial<AxiosRequestConfig>): Promise<DiagramData> {
       const request =
           await Axios({
               ...config,
               method: "get",
               params: null,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/getDiagramData?id=${id}`
           });
       return request.data;
   }

   static async addConfiguration(args: AddConfigArgs, config?: Partial<AxiosRequestConfig>): Promise<DiagramData> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: args,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/addConfiguration`
           });
       return request.data;
   }

   static async bindAndSaveDevice(args: BindAndSaveDeviceArgs, config?: Partial<AxiosRequestConfig>): Promise<DiagramData> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: args,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/bindAndSaveDevice`
           });
       return request.data;
   }

   static async updateSupportSystem(args: PT_ProtectiveFunction, config?: Partial<AxiosRequestConfig>): Promise<DiagramData> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: args,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/updateSupportSystem`
           });
       return request.data;
   }

   static async saveSFT_Targets(targetSpecUpdateParams: TargetSpecUpdateParams, config?: Partial<AxiosRequestConfig>): Promise<DiagramData> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: targetSpecUpdateParams,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/saveSFT_Targets`
           });
       return request.data;
   }

   static async prohibitChanges(pfId: number, diagramData: DiagramData, config?: Partial<AxiosRequestConfig>): Promise<boolean> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: diagramData,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/prohibitChanges?pfId=${pfId}`
           });
       return request.data;
   }

   static async promoteDeviceToClientLevel(args: PromoteDeviceToClientLevelArgs, config?: Partial<AxiosRequestConfig>): Promise<DeviceBarDevices> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: args,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/promoteDeviceToClientLevel`
           });
       return request.data;
   }

   static async checkForCheckoutNmae(pfd: number, config?: Partial<AxiosRequestConfig>): Promise<boolean> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: null,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/checkForCheckoutNmae?pfd=${pfd}`
           });
       return request.data;
   }

   static async bindAndSaveLogic(args: BindAndSaveLogicArgs, config?: Partial<AxiosRequestConfig>): Promise<DiagramData> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: args,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/bindAndSaveLogic`
           });
       return request.data;
   }

   static async bindAndSaveSupport(args: BindAndSaveSupportArgs, config?: Partial<AxiosRequestConfig>): Promise<DiagramData> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: args,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/bindAndSaveSupport`
           });
       return request.data;
   }

   static async bindLogicSolver(logicSolverParams: GetLogicSolverParams, config?: Partial<AxiosRequestConfig>): Promise<LSM_PT_LogicSolverSheet[]> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: logicSolverParams,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/bindLogicSolver`
           });
       return request.data;
   }

   static async bindLogicvoting(pt_protectiveFunctionIdOfLogicSolver: number, config?: Partial<AxiosRequestConfig>): Promise<string[]> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: null,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/bindLogicvoting?pt_protectiveFunctionIdOfLogicSolver=${pt_protectiveFunctionIdOfLogicSolver}`
           });
       return request.data;
   }

   static async bindLogicvotings(logicSource: string, logicDeviceId: string, config?: Partial<AxiosRequestConfig>): Promise<string[]> {
       const request =
           await Axios({
               ...config,
               method: "get",
               params: null,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/bindLogicvotings?logicSource=${encodeURIComponent(logicSource)}&logicDeviceId=${encodeURIComponent(logicDeviceId)}`
           });
       return request.data;
   }

   static async bindLogicTIYears(args: BindLogicTIYearsArgs, config?: Partial<AxiosRequestConfig>): Promise<number[]> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: args,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/bindLogicTIYears`
           });
       return request.data;
   }

   static async bindLogicPfdandStr(args: BindLogicPfdAndStrArgs, config?: Partial<AxiosRequestConfig>): Promise<LST_LogicSolverSheetList> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: args,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/bindLogicPfdandStr`
           });
       return request.data;
   }

   static async updateLogicSolverData(args: UpdateLogicSolverDataArgs, config?: Partial<AxiosRequestConfig>): Promise<DiagramData> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: args,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/updateLogicSolverData`
           });
       return request.data;
   }

   static async bindPasteAndSaveDevice(args: BindPasteAndSaveDeviceArgs, config?: Partial<AxiosRequestConfig>): Promise<DiagramData> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: args,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/bindPasteAndSaveDevice`
           });
       return request.data;
   }

   static async bindSupportSystem(getDataSheetObject: GetDataSheetObject, config?: Partial<AxiosRequestConfig>): Promise<SS_PT_SupportSystemSheet[]> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: getDataSheetObject,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/bindSupportSystem`
           });
       return request.data;
   }

   static async bindDeviceSheet(getDataSheetObject: GetDataSheetObject, config?: Partial<AxiosRequestConfig>): Promise<DM_PT_DataSheet[]> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: getDataSheetObject,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/bindDeviceSheet`
           });
       return request.data;
   }

   static async restoreDeviceSheetData(protectiveFunctionId: number, protectiveId_FK: number, config?: Partial<AxiosRequestConfig>): Promise<DiagramData> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: null,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/restoreDeviceSheetData?protectiveFunctionId=${protectiveFunctionId}&protectiveId_FK=${protectiveId_FK}`
           });
       return request.data;
   }

   static async calculation(protectiveFunctionId: number, config?: Partial<AxiosRequestConfig>): Promise<CalculationResponse> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: null,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/calculation?protectiveFunctionId=${protectiveFunctionId}`
           });
       return request.data;
   }

   static async updateDeviceSheetData(args: DeviceData, config?: Partial<AxiosRequestConfig>): Promise<DiagramData> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: args,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/updateDeviceSheetData`
           });
       return request.data;
   }

   static async saveCCFVoting(model: SaveCCFVotingParams, config?: Partial<AxiosRequestConfig>): Promise<DiagramData> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: model,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/saveCCFVoting`
           });
       return request.data;
   }

   static async getPtProtectiveFunctions(id: number, config?: Partial<AxiosRequestConfig>): Promise<DeviceData[]> {
       const request =
           await Axios({
               ...config,
               method: "get",
               params: null,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/getPtProtectiveFunctions?id=${id}`
           });
       return request.data;
   }

   static async getReportData(projectId?: number, protectiveFunctionId?: number, config?: Partial<AxiosRequestConfig>): Promise<GuiReportData> {
       const request =
           await Axios({
               ...config,
               method: "get",
               params: null,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/getReportData?projectId=${projectId}&protectiveFunctionId=${protectiveFunctionId}`
           });
       return request.data;
   }

   static async saveManualInputs(protectiveFunctionId: number, manualInputs: ManualInputs, config?: Partial<AxiosRequestConfig>): Promise<DiagramData> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: manualInputs,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/saveManualInputs?protectiveFunctionId=${protectiveFunctionId}`
           });
       return request.data;
   }

   static async saveManualAction(protectiveFunctionId: number, manualAction: ManualAction, config?: Partial<AxiosRequestConfig>): Promise<DiagramData> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: manualAction,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/saveManualAction?protectiveFunctionId=${protectiveFunctionId}`
           });
       return request.data;
   }

   static async createManualInputs(protectiveFunctionId: number, config?: Partial<AxiosRequestConfig>): Promise<DiagramData> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: null,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/createManualInputs?protectiveFunctionId=${protectiveFunctionId}`
           });
       return request.data;
   }

   static async createManualAction(protectiveFunctionId: number, config?: Partial<AxiosRequestConfig>): Promise<DiagramData> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: null,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/createManualAction?protectiveFunctionId=${protectiveFunctionId}`
           });
       return request.data;
   }

   static async deleteDevice(args: DeleteDeviceArgs, config?: Partial<AxiosRequestConfig>): Promise<DiagramData> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: args,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/deleteDevice`
           });
       return request.data;
   }

   static async deleteManualAction(protectiveFunctionId: number, config?: Partial<AxiosRequestConfig>): Promise<DiagramData> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: null,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/deleteManualAction?protectiveFunctionId=${protectiveFunctionId}`
           });
       return request.data;
   }

   static async deleteManualInputs(protectiveFunctionId: number, config?: Partial<AxiosRequestConfig>): Promise<DiagramData> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: null,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/deleteManualInputs?protectiveFunctionId=${protectiveFunctionId}`
           });
       return request.data;
   }

   static async openDeviceSheet(deviceId: string, config?: Partial<AxiosRequestConfig>): Promise<DM_DataSheet_Bar> {
       const request =
           await Axios({
               ...config,
               method: "get",
               params: null,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/openDeviceSheet?deviceId=${encodeURIComponent(deviceId)}`
           });
       return request.data;
   }

   static async openSupportSheet(supportSystemId: string, config?: Partial<AxiosRequestConfig>): Promise<SS_SupportSystemSheet_Bar> {
       const request =
           await Axios({
               ...config,
               method: "get",
               params: null,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/openSupportSheet?supportSystemId=${encodeURIComponent(supportSystemId)}`
           });
       return request.data;
   }

   static async openLogicSolver(logicSolverId: string, config?: Partial<AxiosRequestConfig>): Promise<LSM_LogicSolverSheet_Bar> {
       const request =
           await Axios({
               ...config,
               method: "get",
               params: null,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/openLogicSolver?logicSolverId=${encodeURIComponent(logicSolverId)}`
           });
       return request.data;
   }

   static async position_DeleteDevice(args: Position_DeleteDeviceArgs, config?: Partial<AxiosRequestConfig>): Promise<DiagramData> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: args,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/position_DeleteDevice`
           });
       return request.data;
   }

   static async positionPasteAndSaveDevice(args: PositionPasteAndSaveDeviceArgs, config?: Partial<AxiosRequestConfig>): Promise<DiagramData> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: args,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/positionPasteAndSaveDevice`
           });
       return request.data;
   }

   static async upgradeProtectiveFunction(protectiveFunctionId: number, config?: Partial<AxiosRequestConfig>): Promise<DiagramData> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: null,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/upgradeProtectiveFunction?protectiveFunctionId=${protectiveFunctionId}`
           });
       return request.data;
   }

   static async userHasCustomDeviceRights(config?: Partial<AxiosRequestConfig>): Promise<boolean> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: null,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/userHasCustomDeviceRights`
           });
       return request.data;
   }

   static async saveCustomDeviceSheet(dm_dataSheet: DM_DataSheet, projectId: number, config?: Partial<AxiosRequestConfig>): Promise<DeviceBarDevices> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: dm_dataSheet,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/saveCustomDeviceSheet?projectId=${projectId}`
           });
       return request.data;
   }

   static async saveCustomLogicSolver(lsm_LogicSolverSheet: LSM_LogicSolverSheet, projectId: number, config?: Partial<AxiosRequestConfig>): Promise<DeviceBarDevices> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: lsm_LogicSolverSheet,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/saveCustomLogicSolver?projectId=${projectId}`
           });
       return request.data;
   }

   static async saveCustomSupportSystem(ss_supportSystemSheet: SS_SupportSystemSheet, projectId: number, config?: Partial<AxiosRequestConfig>): Promise<DeviceBarDevices> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: ss_supportSystemSheet,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/saveCustomSupportSystem?projectId=${projectId}`
           });
       return request.data;
   }

   static async deleteCustomDeviceSheet(dm_dataSheet: DM_DataSheet, projectId: number, config?: Partial<AxiosRequestConfig>): Promise<DeviceBarDevicesAndPfString> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: dm_dataSheet,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/deleteCustomDeviceSheet?projectId=${projectId}`
           });
       return request.data;
   }

   static async deleteCustomLogic(lsm_logicSolverSheet: LSM_LogicSolverSheet, projectId: number, config?: Partial<AxiosRequestConfig>): Promise<DeviceBarDevicesAndPfString> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: lsm_logicSolverSheet,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/deleteCustomLogic?projectId=${projectId}`
           });
       return request.data;
   }

   static async deleteCustomSupport(ss_SupportSystemSheet: SS_SupportSystemSheet, projectId: number, config?: Partial<AxiosRequestConfig>): Promise<DeviceBarDevicesAndPfString> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: ss_SupportSystemSheet,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/deleteCustomSupport?projectId=${projectId}`
           });
       return request.data;
   }

   static async saveProcessHazard(pSF_ProtectiveFunctionComments: PSF_ProtectiveFunctionComments, config?: Partial<AxiosRequestConfig>): Promise<DiagramData> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: pSF_ProtectiveFunctionComments,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/saveProcessHazard`
           });
       return request.data;
   }

   static async saveDescription(pSF_ProtectiveFunctionComments: PSF_ProtectiveFunctionComments, config?: Partial<AxiosRequestConfig>): Promise<DiagramData> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: pSF_ProtectiveFunctionComments,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/saveDescription`
           });
       return request.data;
   }

   static async saveDiagnostics(pSF_ProtectiveFunctionComments: PSF_ProtectiveFunctionComments, config?: Partial<AxiosRequestConfig>): Promise<DiagramData> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: pSF_ProtectiveFunctionComments,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/saveDiagnostics`
           });
       return request.data;
   }

   static async saveReset(pSF_ProtectiveFunctionComments: PSF_ProtectiveFunctionComments, config?: Partial<AxiosRequestConfig>): Promise<DiagramData> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: pSF_ProtectiveFunctionComments,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/saveReset`
           });
       return request.data;
   }

   static async saveShutdown(pSF_ProtectiveFunctionComments: PSF_ProtectiveFunctionComments, config?: Partial<AxiosRequestConfig>): Promise<DiagramData> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: pSF_ProtectiveFunctionComments,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/saveShutdown`
           });
       return request.data;
   }

   static async saveReference(pSF_ProtectiveFunctionComments: PSF_ProtectiveFunctionComments, config?: Partial<AxiosRequestConfig>): Promise<DiagramData> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: pSF_ProtectiveFunctionComments,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/saveReference`
           });
       return request.data;
   }

   static async saveComments(pSF_ProtectiveFunctionComments: PSF_ProtectiveFunctionComments, config?: Partial<AxiosRequestConfig>): Promise<DiagramData> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: pSF_ProtectiveFunctionComments,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/saveComments`
           });
       return request.data;
   }

   static async updateProtectiveFunctionLock(id: number, config?: Partial<AxiosRequestConfig>): Promise<boolean> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: null,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/updateProtectiveFunctionLock?id=${id}`
           });
       return request.data;
   }

   static async isLocked(pf: ProtectiveFunction, config?: Partial<AxiosRequestConfig>): Promise<boolean> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: pf,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/isLocked`
           });
       return request.data;
   }

   static async releaseProtectiveFunctionLock(id: number, config?: Partial<AxiosRequestConfig>): Promise<void> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: null,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/releaseProtectiveFunctionLock?id=${id}`
           });
       return request.data;
   }

   static async getUserDetails(config?: Partial<AxiosRequestConfig>): Promise<UserDetails> {
       const request =
           await Axios({
               ...config,
               method: "get",
               params: null,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/DiagramApi/getUserDetails`
           });
       return request.data;
   }
}